export enum InvoiceTypeEnum {
  Invoice = 'INVOICE', // Faktura
  Credit = 'CREDIT_INVOICE', // Kreditfaktura
  LatePaymentInterest = 'LATE_PAYMENT_INTEREST_INVOICE', // Dröjsmålsräntefaktura
  NoType = 'NO_TYPE',
}
